var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.$store.getters.loadingMap[_vm.$store.getters.currentPath],
          expression: "$store.getters.loadingMap[$store.getters.currentPath]",
        },
      ],
      staticStyle: { "background-color": "#f7f8fa" },
    },
    [
      _c(
        "de-main-container",
        { class: { "full-height": _vm.fullHeightFlag } },
        [
          _c("panel-main", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.componentName === "PanelMain",
                expression: "componentName==='PanelMain'",
              },
            ],
            ref: "panel_main",
          }),
          _vm.componentName === "PanelEdit" ? _c("panel-edit") : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }